import styled from 'styled-components';
import { Button } from 'antd';

export const PercentBadgeContainer = styled.div<{ $visible?: boolean }>`
  height: ${({ $visible }) => ($visible ? '24px' : '0')};
  display: flex;
  align-items: center;
  width: 100%;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
`;

export const ChartWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 420px;
  height: 150px;
  padding: 10px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
`;

export const TrendContainer = styled.div`
  display: flex;
  align-items: flex-end;
  overflow: visible;
  height: 100%;
  width: 100%;
  flex: 1;
  min-height: 65px;
`;

export const TitleRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  gap: 4px;
`;

export const StyledTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #575757;
  user-select: none;
  flex: 1;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DrilldownIconButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 20px;
  height: 20px;
  min-width: 20px;
  border: none;
  background: transparent;
  color: #8c8c8c;
  flex-shrink: 0;

  &:hover {
    color: #1890ff;
    background: rgb(24 144 255 / 10%);
  }

  .anticon {
    font-size: 14px;
  }
`;

export const ContentRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
`;

export const ValueSection = styled.div<{ $centered?: boolean }>`
  display: flex;
  flex-direction: row;
  gap: 4px;
  flex: 0 0 auto;
  align-items: flex-start;
  width: 100%;
  justify-content: flex-start;
`;

export const StyledValue = styled.div<{ $isEmpty?: boolean }>`
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  color: ${({ $isEmpty }) => ($isEmpty ? '#8c8c8c' : '#242424')};
  user-select: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const UnitText = styled.span`
  font-size: 14px;
  font-weight: 400;
`;

export const BadgeContainer = styled.div`
  height: 24px;
  display: flex;
  align-items: center;
`;

export const PercentBadge = styled.span<{ positive?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  color: ${({ positive }) => (positive ? '#16a34a' : '#dc2626')};
  line-height: 1.2;

  .anticon {
    font-size: 14px;
    margin-top: 1px;
  }
`;

export const EmptyStateContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #bfbfbf;
  font-size: 12px;
  min-height: 60px;
  font-style: italic;
`;
